var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessenger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.7C0 4.1264 4.3667 0 10 0C15.6333 0 20 4.1264 20 9.7C20 15.2736 15.6333 19.4 10 19.4C8.98816 19.4 8.0174 19.2664 7.1053 19.0156C6.928 18.9668 6.73946 18.9806 6.5712 19.0548L4.58634 19.931C4.06714 20.1602 3.48106 19.791 3.46366 19.2236L3.4092 17.4448C3.4025 17.2256 3.3039 17.0208 3.14056 16.8746C1.1948 15.1346 0 12.6154 0 9.7ZM6.93255 7.87638L3.99505 12.5368C3.71315 12.984 4.26291 13.488 4.68405 13.1684L7.83941 10.7737C8.05285 10.6117 8.34781 10.6109 8.56215 10.7716L10.8985 12.5239C11.5996 13.0498 12.6002 12.8651 13.0675 12.1238L16.005 7.46334C16.2868 7.01608 15.7371 6.51208 15.3159 6.83168L12.1606 9.22638C11.9471 9.38838 11.6522 9.38924 11.4378 9.22844L9.10151 7.47618C8.40041 6.95038 7.39981 7.13498 6.93255 7.87638Z",
    fill: "url(#paint0_linear_34387_114242)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_34387_114242",
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E55C8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509615,
    stopColor: "#6A53F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4184F7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessenger);
export default __webpack_public_path__ + "static/media/messenger.0e6acf06cb051e4b2be05db9879eb5ff.svg";
export { ForwardRef as ReactComponent };